import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Map } from 'mapbox-gl';
import { catchError, debounceTime, Observable, of, Subject, switchMap, takeUntil } from 'rxjs';
import { Busca, Hotel, HotelMapa } from 'src/app/model';
import { HotelService, MapaService, Util } from 'src/app/services';

class BuscaReferenciaLocalizacao {
  coordinates: number[];
  display_field: string;
}

@Component({
  selector: 'app-hotel-mapa',
  standalone: false,
  templateUrl: './hotel-mapa.component.html',
  styleUrl: './hotel-mapa.component.scss'
})
export class HotelMapaComponent {
  modalRefHotel: NgbModalRef;

  @Input() guid: string;
  @Input() busca: Busca;

  @Output() selecionouHotel = new EventEmitter<Hotel>();
  @Output() removerHotel = new EventEmitter<Hotel>();
  @Output() rebuscar = new EventEmitter<void>();
  @Output() trocarHotelFornecedorEmitter = new EventEmitter<{ agrupador: string, hotel: Hotel }>();

  private debouncer: Subject<void> = new Subject<void>();
  private unsubscribe: Subject<void> = new Subject<void>();

  hotelList: Hotel[] = [];
  refHotel: Hotel;
  map: Map;
  referenciasPesquisada: BuscaReferenciaLocalizacao[] = null;
  referenciaPesquisada: BuscaReferenciaLocalizacao = new BuscaReferenciaLocalizacao();

  lat: number = -22.9035;
  lng: number = -43.2096;
  minZoom: number = 1;
  zoom: number = 4;

  timerRefencia: any = null;
  mapHoteis: HotelMapa[] = [];

  showInfo: boolean = false;

  constructor(
    private hotelService: HotelService,
    private modalService: NgbModal,
    private mapaService: MapaService
  ) { }

  ngOnInit() {
    this.referenciaPesquisada = new BuscaReferenciaLocalizacao();
    this.referenciasPesquisada = [];
    this.debouncer.pipe(
      debounceTime(1000),
      switchMap(() => {
        return this.filterHotel();
      }),
      takeUntil(this.unsubscribe)
    ).subscribe(
      (data: any[]) => {
        this.mapHoteis = data;
        this.zoom = 15
        this.carregando = false;
      },
      (error) => {
        console.error('Erro ao buscar hoteis:', error);
      }
    );

    this.puxaCidadePrincipal();
  }

  trocarHotelFornecedor(agrupador, hotel) {
    this.trocarHotelFornecedorEmitter.emit({ agrupador, hotel });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onMapInteraction(): void {
    this.debouncer.next();
  }

  posicaoDoMapa(latitude: number, longitude: number): string {
    const bounds = this.map.getBounds();
    const { lat: NLat, lng: NLong } = bounds.getNorthWest();
    const { lat: SLat, lng: SLong } = bounds.getSouthEast();

    const centerLat = (NLat + SLat) / 2;
    const centerLong = (NLong + SLong) / 2;

    const latRange = Math.abs(NLat - SLat);
    const longRange = Math.abs(NLong - SLong);

    const latThreshold = centerLat + latRange * 0.15;
    const latLowerThreshold = centerLat - latRange * 0.20;

    const longRightThreshold = centerLong + longRange * 0.25;
    const longLeftThreshold = centerLong - longRange * 0.25;

    const acima = latitude > latThreshold;
    const abaixo = latitude < latLowerThreshold;
    const direita = longitude > longRightThreshold;
    const esquerda = longitude < longLeftThreshold;

    if (acima && esquerda) return "top-left";
    if (acima && direita) return "top-right";
    if (acima) return "top";
    if (abaixo && esquerda) return "bottom-left";
    if (abaixo && direita) return "bottom-right";
    if (abaixo) return "bottom";
    if (esquerda) return "left";
    if (direita) return "right";

    return "bottom"; // default
  }

  puxaCidadePrincipal(): void {
    var nomeCidade = this.busca.trechos[0].cidadeDestino.Nome + ", " + this.busca.trechos[0].cidadeDestino.Estado.Nome + ", " + this.busca.trechos[0].cidadeDestino.Estado.Pais.Nome;
    if (nomeCidade.length > 0) {
      this.mapaService.pesquisaLocalizacaoInicial(nomeCidade).subscribe((coords) => {
        this.lat = coords.lat;
        this.lng = coords.lng;
        this.zoom = 15;
      }, (error) => {
        console.error('Erro ao buscar localização:', error);
      });
    }
  }

  buscaReferencia(val: string) {
    this.referenciasPesquisada = [];
    const { lat: NLat, lng: NLong } = this.map?.getBounds().getNorthWest();

    this.mapaService.searchLocalizacao(val, NLong.toString() + "," + NLat.toString()).subscribe(
      (dados) => {
        dados.features.forEach(feature => {
          const referencias = new BuscaReferenciaLocalizacao();

          referencias.display_field = feature.place_name;
          if (referencias.display_field == null || referencias.display_field == undefined || referencias.display_field == '') {
            referencias.display_field = feature.text + ', ' + feature.context.filter(y => y.id.includes("place") || y.id.includes("country")).map(y => y.text).join(', ');
          }

          referencias.coordinates = feature.geometry.coordinates;
          this.referenciasPesquisada.push(referencias);
        });
      },
      (erro) => {
        console.log(erro);
        this.referenciasPesquisada = [];
      }
    );
  }

  buscaRefenciaDebounce(val: string) {
    clearTimeout(this.timerRefencia);
    this.timerRefencia = setTimeout(() => {
      this.buscaReferencia(val);
    }, 1000);
  }

  selecionouReferencia(referencia: BuscaReferenciaLocalizacao) {
    this.referenciaPesquisada = referencia
    this.lat = referencia.coordinates[1];
    this.lng = referencia.coordinates[0];
    this.zoom = 15;
    this.referenciasPesquisada = [];
    this.referenciaPesquisada = new BuscaReferenciaLocalizacao();
  }
  carregando: boolean = false;
  filterHotel(): Observable<any[]> {
    this.carregando = true;
    if (!this.map) {
      this.carregando = false;
      return of([]);
    }

    const { lat: NLat, lng: NLong } = this.map.getBounds().getNorthWest();
    const { lat: SLat, lng: SLong } = this.map.getBounds().getSouthEast();
    const parametros = { NLat, NLong, SLat, SLong, Guid: this.guid, Zoom: this.map.getZoom() };

    return this.hotelService.buscarMapaHotel(parametros)
      .pipe(

        catchError((error) => {
          this.rebuscar.emit();
          return of([]);
        })
      );
  }

  levarAoHotel(codigoFornecedor: string, contentHotel: any): void {
    this.hotelService.buscarHotelEspecifico(codigoFornecedor, this.guid)
      .subscribe(
        (data) => {
          data.Id = data.Id * -1;
          data.selecionado = false;
          data.QuantidadeSelecionada = false;
          const opcoes = data.Quartos.map(q => q.Pesquisa).filter(this.distinct).sort();

          data.opcoes = [];

          for (let i = 0; i < opcoes.length; i++) {
            data.opcoes.push(data.Quartos.filter(x => x.Pesquisa == opcoes[i]));
          }

          if (data.Offline && data.Imagens) {
            data.Imagens = data.Imagens.map(x => {
              x = Util.pathImagemApi(x);
              return x;
            });
          }

          data.Quartos = [];
          data.melhorPreco = 0;

          for (let i = 0; i < opcoes.length; i++) {
            data.Quartos.push(data.opcoes[i][0]);
            data.melhorPreco += data.opcoes[i][0].ValorListagem;
          }

          this.refHotel = data;

          this.modalRefHotel = this.modalService.open(contentHotel, { size: 'xl' });
          this.modalRefHotel.result.then();
        },
        (error) => {
          this.rebuscar.emit();
        });
  }

  distinct = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  fecharModalHotel(): void {
    this.modalService.dismissAll();
  }

  selecionoHotel(hotel: Hotel): void {
    this.selecionouHotel.emit(hotel);
  }

  removeuHotel(hotel: Hotel): void {
    this.removerHotel.emit(hotel);
  }

}
